import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { reportDetail, policyDetail, claimsManagementStore } from './request';
import singleChoice from '@/views/questionnaire/customerManage/questionnaireList/components/singleChoice.vue';
import tableControl from '@/views/questionnaire/customerManage/questionnaireList/components/tableControl.vue';
import multipleChoice from '@/views/questionnaire/customerManage/questionnaireList/components/multipleChoice.vue';
import dateControl from '@/views/questionnaire/customerManage/questionnaireList/components/dateControl.vue';
import dropDownSelect from '@/views/questionnaire/customerManage/questionnaireList/components/dropDownSelect.vue';
import signModel from '@/views/questionnaire/customerManage/questionnaireList/components/signModel.vue'; //签名组件
import paragraphModel from '@/views/questionnaire/customerManage/questionnaireList/components/paragraphModel.vue'; //段落
import enclosureModel from '@/views/questionnaire/customerManage/questionnaireList/components/enclosureModel.vue'; //附件
import singleLineMultilineModel from '@/views/questionnaire/customerManage/questionnaireList/components/singleLineMultilineModel.vue'; //单行文本and多行文本
import formControlItem from '@/components/examine/formControlItem.vue';
import previewFileModel from '@/views/components/previewFile/previewFileModel.vue';
import emailSendModel from '@/views/components/emailSend/emailSendModel.vue';
import topTitle from '@/components/title';
import formItemMixin from '@/mixins/formItemMixin';
import { mapState } from 'vuex';
import { checkEmail } from '@/utils/validate';
export default {
  data() {
    return {
      reportDetail: {},
      policyInfo: {},
      formData: {},
      showControl: {},
      rules: {},
      associationInfo: {},
      vidateStatus: true,
      submitData: [],
      formItems: [],
      //获取的数据
      actionButton: [],
      showSendEmail: false,
      notifyData: null,
      showPreviewFile: false,
      previewFileList: [],
      loading: false
    };
  },
  mixins: [formItemMixin],
  components: {
    topTitle,
    singleChoice,
    tableControl,
    multipleChoice,
    dateControl,
    dropDownSelect,
    signModel,
    paragraphModel,
    enclosureModel,
    singleLineMultilineModel,
    formControlItem,
    previewFileModel,
    emailSendModel
  },
  created() {
    policyDetail({
      policyId: this.$route.params.id
    }).then(res => {
      this.policyInfo = res.policyInfo;
      this.policyInfo.customerName = res.baseInfo.customerName;
    });
    this.$store.dispatch('quiretionnaire/getResource');
    // this.getReportDetail();
  },
  computed: {
    ...mapState({
      countriesData: state => state.quiretionnaire.countriesData,
      provinceFirstLevel: state => state.quiretionnaire.provinceFirstLevel,
      provinceData: state => state.quiretionnaire.provinceData,
      provinceArea: state => state.quiretionnaire.provinceArea,
      logisticsData: state => state.quiretionnaire.logisticsData,
      bankData: state => state.quiretionnaire.bankData
    })
  },
  mounted() {
    this.getReportDetail();
  },
  methods: {
    // validateEmail(rules, value, callback) {
    //   if (value && !checkEmail(value)) {
    //     callback(new Error(this.$t('邮箱格式有误，请重新填写')));
    //   }
    //   callback();
    // },
    valueChangeValidate(key) {
      this.$refs.form.validateField(key);
    },
    validateTable() {
      //验证表格数据
      this.formItems && Array.isArray(this.formItems) && this.formItems.forEach(nodeItem => {
        nodeItem.form.forEach(controlItem => {
          if (controlItem.controlType === 'controlGroup') {
            //控件组
            controlItem.control.forEach(item => {
              if (item.partsType === 'table' && this.showControl[item.mark]) {
                this.$refs[`control${item.mark}`][0].validateTable();
              }
            });
          } else if (controlItem.control.partsType === 'table' && this.showControl[controlItem.control.mark]) {
            this.$refs[`control${controlItem.control.mark}`][0].validateTable();
          }
        });
      });
      let validateStatus = true;
      let length = this.formItems && Array.isArray(this.formItems) ? this.formItems.length : 0;
      for (let i = 0; i < length; i++) {
        let nodeItem = this.formItems[i];
        for (let j = 0; j < nodeItem.form.length; j++) {
          let controlItem = nodeItem.form[j];
          if (controlItem.controlType === 'controlGroup') {
            //控件组
            for (let k = 0; k < controlItem.control.length; k++) {
              let item = controlItem.control[k];
              if (item.partsType === 'table' && this.showControl[item.mark]) {
                if (!this.$refs[`control${item.mark}`][0].$refs[`table${item.mark}`].validateStatus) {
                  validateStatus = false;
                }
                if (!validateStatus) {
                  break;
                }
              }
            }
          } else if (controlItem.control.partsType === 'table' && this.showControl[controlItem.control.mark]) {
            if (!this.$refs[`control${controlItem.control.mark}`][0].$refs[`table${controlItem.control.mark}`].validateStatus) {
              validateStatus = false;
            }
          }
          if (!validateStatus) {
            break;
          }
        }
        if (!validateStatus) {
          break;
        }
      }
      return validateStatus;
    },
    getReportDetail() {
      reportDetail({
        auditFlowId: this.$route.params.auditFlowId
      }).then(res => {
        let editableArea = res.editableArea;
        this.actionButton = res.actionButton;
        // 对接口返回的数据进行处理
        editableArea && Array.isArray(editableArea) && editableArea.forEach(item => {
          item.form.forEach(control => {
            var _controlItem$associat;
            if (control.controlType === 'control') {
              var _control$control;
              control.control.mark = (_control$control = control.control) === null || _control$control === void 0 ? void 0 : _control$control.mark.replace('d.', 'd_');
              if (control.control.partsType === 'multipleChoice') {
                this.$set(this.formData, control.control.mark, []);
              }
            } else {
              control.mark = control.mark.replace('d.', 'd_');
              let groupControl = control.control;
              groupControl.forEach(item => {
                item.mark = item.mark.replace('d.', 'd_');
              });
            }
            //设置控件显隐 以及处理关联关系
            let mark = control.controlType === 'control' ? control.control.mark : control.mark;
            let controlItem = control.controlType === 'control' ? control.control : control;
            if ((controlItem === null || controlItem === void 0 || (_controlItem$associat = controlItem.association) === null || _controlItem$associat === void 0 || (_controlItem$associat = _controlItem$associat.association) === null || _controlItem$associat === void 0 ? void 0 : _controlItem$associat.length) > 0) {
              let key = controlItem.association.association[0].hideControl.replace('d.', 'd_');
              let value = controlItem.association.association[0];
              value.targetKey = mark;
              if (Array.isArray(this.associationInfo[key])) {
                this.associationInfo[key].push(value);
              } else {
                this.associationInfo[key] = [value];
              }
              this.$set(this.showControl, mark, false);
            } else {
              this.$set(this.showControl, mark, true);
            }
          });
        });
        this.formatRules(editableArea);
        this.formItems = editableArea;
      });
    },
    formatRules(editableArea) {
      editableArea && Array.isArray(editableArea) && editableArea.forEach(item2 => {
        item2.form.forEach(item3 => {
          if (item3.controlType === 'control') {
            let rules = this.generateValidateRule(item3.control);
            if (rules.length > 0) {
              this.$set(this.rules, item3.control.mark, rules);
            }
          } else if (item3.controlType === 'controlGroup') {
            item3.control.forEach(item4 => {
              let rules = this.generateValidateRule(item4);
              if (rules.length > 0) {
                this.$set(this.rules, item4.mark, rules);
              }
            });
          }
        });
      });
      console.log(this.rules, 'this.rules');
    },
    changeControlShow(value, key) {
      this.$set(this.showControl, key, value);
    },
    generateTableData() {
      this.formItems && Array.isArray(this.formItems) && this.formItems.forEach(nodeItem => {
        nodeItem.form.forEach(controlItem => {
          var _controlItem$control;
          if (controlItem.controlType === 'controlGroup') {
            controlItem.control.forEach(item => {
              if (item.partsType === 'table' && this.showControl[controlItem.mark]) {
                this.$refs[`control${item.mark}`][0].generationData();
              }
            });
          } else if (((_controlItem$control = controlItem.control) === null || _controlItem$control === void 0 ? void 0 : _controlItem$control.partsType) === 'table' && this.showControl[controlItem.control.mark]) {
            this.$refs[`control${controlItem.control.mark}`][0].generationData();
          }
        });
      });
    },
    handleControlValue(controlItem) {
      //处理控件的value值
      if (controlItem.partsType === 'table' && this.showControl[controlItem.mark]) {
        // controlItem.controlValue = this.$refs[`table${controlItem.mark}`][0].formDataArray;
        // this.$refs[`table${controlItem.mark}`][0].generationData2();
        controlItem.mark = controlItem.mark.replace('d_', 'd.');
      } else if (controlItem.partsType === 'dropDown') {
        let value = this.formData[controlItem.mark];
        controlItem.value = this.handleDropDownData(value, controlItem);
        delete controlItem.dataList;
        controlItem.mark = controlItem.mark.replace('d_', 'd.');
      } else {
        controlItem.value = this.formData[controlItem.mark] || '';
        controlItem.mark = controlItem.mark.replace('d_', 'd.');
      }
    },
    handleDropDownData(value, item) {
      //下拉选择的value格式处理
      if (!value) {
        return {
          textValue: [],
          codeValue: []
        };
      }
      const generaterText = mapObj => {
        let textValue = [];
        value.forEach(valueArr => {
          let text = '';
          if (Array.isArray(valueArr) && valueArr.length > 0) {
            //多选
            valueArr.forEach((value, index) => {
              if (index === valueArr.length - 1) {
                text = text + mapObj[value];
              } else {
                text = text + mapObj[value] + '/';
              }
            });
          } else {
            //单选
            text = mapObj[valueArr];
          }
          textValue.push(text);
        });
        return textValue;
      };
      let textData = [];
      let dataType = item.type.type;
      if (dataType === 'provinceArea') {
        textData = generaterText(this.provinceAreaObj);
      } else if (dataType === 'province') {
        textData = generaterText(this.provinceDataObj);
      } else if (dataType === 'provinceFirstLevel') {
        textData = generaterText(this.provinceFirstLevelObj);
      } else if (dataType === 'country') {
        textData = generaterText(this.countriesDataMap);
      } else if (dataType === 'bank') {
        textData = generaterText(this.bankDataObj);
      } else if (dataType === 'logistics') {
        textData = generaterText(this.logisticsDataObj);
      } else if (dataType === 'custom') {
        const loop = (data, obj) => {
          data.forEach(item => {
            obj[item.id] = item.name;
            if (item.children) {
              loop(item.children, obj);
            }
          });
          return obj;
        };
        let mapObj = loop(item.dataList, {});
        textData = generaterText(mapObj);
      }
      return {
        textValue: textData,
        codeValue: value
      };
    },
    onSubmit(buttonItem) {
      let tableValidateStatus = this.validateTable();
      if (!tableValidateStatus) {
        this.vidateStatus = false;
        return;
      }
      this.formatDropResourceMap();
      this.$refs.form.validate(valid => {
        this.vidateStatus = valid;
        if (valid) {
          this.generateTableData();
          this.submitData = JSON.parse(JSON.stringify(this.formItems));
          this.submitData && Array.isArray(this.submitData) && this.submitData.forEach(nodeItem => {
            nodeItem.form.forEach(controlItem => {
              if (controlItem.controlType === 'controlGroup') {
                controlItem.control.forEach(item => {
                  this.handleControlValue(item);
                });
              } else {
                this.handleControlValue(controlItem.control);
              }
            });
          });
          if (buttonItem.goBack === 'PREVIEW_FILE') {
            //附件按钮
            // let params = {
            //   policyId: this.$route.params.id,
            //   auditFlowId: this.$route.params.auditFlowId,
            //   actionButton: buttonItem,
            //   editableArea: JSON.stringify(this.submitData)
            // };
            // this.showPreviewFile = true;
            // this.requestSave(params, 'PREVIEW_FILE');
          } else {
            //如果按钮有发送邮件的功能 打开发送邮件的弹窗
            if (buttonItem.notify.length > 0) {
              this.notifyData = buttonItem;
              this.$nextTick(() => {
                this.showSendEmail = true;
              });
            } else {
              let params = {
                policyId: this.$route.params.id,
                auditFlowId: this.$route.params.auditFlowId,
                actionButton: buttonItem,
                editableArea: JSON.stringify(this.submitData)
              };
              this.requestSave(params);
              // console.log(params, 'params');
            }
          }
        }
      });
    },
    requestSave(params, type) {
      this.loading = true;
      claimsManagementStore(params).then(res => {
        this.loading = false;
        if (type === 'PREVIEW_FILE') {
          var _res$previewFiles;
          this.previewFileList = [];
          (_res$previewFiles = res.previewFiles) === null || _res$previewFiles === void 0 || _res$previewFiles.forEach((item, index) => {
            this.previewFileList.push({
              name: item.fileName,
              url: item.filePath,
              uid: index + 1,
              status: 'done'
            });
          });
        } else {
          this.$router.push('/claim/customerReportManage');
          this.$message.success(this.$t('提交成功'));
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    formatDropResourceMap() {
      const loop = (data, obj) => {
        data.forEach(item => {
          obj[item.id] = item.name;
          if (item.children) {
            loop(item.children, obj);
          }
        });
        return obj;
      };
      this.countriesDataMap = loop(this.countriesData, {});
      this.provinceFirstLevelObj = loop(this.provinceFirstLevel, {});
      this.provinceDataObj = loop(this.provinceData, {});
      this.provinceAreaObj = loop(this.provinceArea, {});
      this.logisticsDataObj = loop(this.logisticsData, {});
      this.bankDataObj = loop(this.bankData, {});
    },
    closeModel(notifyData) {
      this.showSendEmail = false;
      const formItems = JSON.parse(JSON.stringify(this.formItems));
      formItems && Array.isArray(formItems) && formItems.forEach(nodeItem => {
        nodeItem.form.forEach(controlItem => {
          if (controlItem.controlType === 'controlGroup') {
            controlItem.control.forEach(item => {
              this.handleControlValue(item);
            });
          } else {
            this.handleControlValue(controlItem.control);
          }
        });
      });
      let params = {
        policyId: this.$route.params.id,
        auditFlowId: this.$route.params.auditFlowId,
        actionButton: notifyData,
        editableArea: JSON.stringify(formItems)
      };
      this.requestSave(params);
    },
    restPreviewFile() {
      this.previewFileList = [];
      this.showPreviewFile = false;
    }
  }
};